import React from 'react';
import "./Carousel.css";
import Carousel, { consts } from "react-elastic-carousel";
import { GoArrowRight } from "react-icons/go";
import { GoArrowLeft } from "react-icons/go";

export default function CarouselSlider({children}) {
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2},
    { width: 992, itemsToShow: 3 },
    { width: 1150, itemsToShow: 4 },
    { width: 1450, itemsToShow: 4 },
    { width: 1750, itemsToShow: 4 },
  ];

  const customArrow = ({ type, onClick, isEdge }) => {
    const pointer = type === consts.PREV ? <GoArrowLeft size={25}/> : <GoArrowRight size={25}/>;
    return (
      <button
        onClick={onClick}
        disabled={isEdge}
        className={`custom-arrow ${type === consts.PREV ? "custom-arrow-left" : "custom-arrow-right"}`}
      >
        {pointer}
      </button>
    );
  };

  return (
    <Carousel breakPoints={breakPoints} pagination={false} renderArrow={customArrow}>
      {children}
    </Carousel>
  )
}
